import { render, staticRenderFns } from "./rotatingferriswheel.vue?vue&type=template&id=3237ee1e&"
import script from "./rotatingferriswheel.vue?vue&type=script&lang=js&"
export * from "./rotatingferriswheel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports